// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA6Ja99ugE92BP7iMsg-H02c3F0QWNVw-w",
  authDomain: "chatsmith-9e637.firebaseapp.com",
  projectId: "chatsmith-9e637",
  storageBucket: "chatsmith-9e637.firebasestorage.app",
  messagingSenderId: "184706743678",
  appId: "1:184706743678:web:69d4d166170c3f0c4a072f",
  measurementId: "G-V7VCG3G0ZS"
};

// Initialize Firebase only if it hasn't been initialized already
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
export const storage = getStorage(app);

export default app; 